<div class="component-heading flex flex-row justify-start items-center"
     *ngIf="!selectedConversationIds || (selectedConversationIds && selectedConversationIds?.length === 0)">
  Conversations
</div>
<div class="component-heading flex flex-row justify-start items-center"
     *ngIf="selectedConversationIds && selectedConversationIds?.length > 0">
  <span>{{selectedConversationIds?.length }}</span>&nbsp;Conversations Selected
</div>
<div class="action-heading flex flex-row justify-between items-center">
  <a class="link-color" (click)="deleteConversations()"
     [ngClass]="{'disable': selectedConversationIds && selectedConversationIds.length === 0}"
     particleAnalytics
     analyticsCategory="conversation-list"
     analyticsAction="edit-btn">Delete</a>
  <a class="link-color" (click)="navigateToConversationList()"
     particleAnalytics
     analyticsCategory="conversation-list"
     analyticsAction="new-btn">Done</a>
</div>

<div class="rest-of simple-scroll">
  <div *ngFor="let conversation of conversationList">

    <div *ngIf="conversation.titleAvatarInfo || conversation.isGroupConversation"
         [ngClass]="{'selected-conversation': conversation.isSelected}"
         class="conversation-container flex flex-row">
      <mat-checkbox
        [disabled]="conversation.isDefault"
        [(ngModel)]="conversation.isSelected"
        (change)="onSelectionChange($event)"
      >
      </mat-checkbox>
      <div class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
        <collaboration-avatar *ngIf="conversation.sourceType === 'DAC6'"
                              [gravatarInfo]="conversation.titleAvatarInfo"
                              [showCaseAvatar]="true"
                              [showGroupAvatar]="conversation.isGroupConversation"></collaboration-avatar>
        <collaboration-avatar *ngIf="conversation.sourceType !== 'DAC6'"
                              [gravatarInfo]="conversation.titleAvatarInfo"
                              [showCaseAvatar]="false"
                              [showGroupAvatar]="conversation.isGroupConversation"></collaboration-avatar>

        <div class="flex flex-col" style="flex:0 0 185px">
          <div class="flex flex-row justify-between items-center">
            <span class="user-name full-grow-no-shrink-no-basis"
                  matTooltip="{{conversation?.title}}">{{conversation?.title}}</span>
            <span
              class="timing">{{conversation.messages.length > 0 ? (conversation.messages[conversation.messages.length - 1]?.createdDate | timeAgo) : ''}}</span>
          </div>
          <div class="description-container flex flex-col">
            <div class="description full-grow-no-shrink-no-basis"
                 [innerHtml]="conversation.messages[conversation.messages.length - 1]?.message"></div>
            <i [class]="conversation.unreadMessageCount<=0?  'fa fa-check showBlock': 'fa fa-check hideBlock'"
               class="fa fa-check"></i>
            <span
              [class]="conversation.unreadMessageCount>0?  'unread-counting-tag showBlock': 'unread-counting-tag hideBlock'"
              class="flex flex-row justify-center items-center">
        {{conversation.unreadMessageCount}}
      </span>
          </div>
        </div>
      </div>
    </div>


  </div>

</div>

